import { Button } from "@chakra-ui/button";
import { FormControl, FormLabel } from "@chakra-ui/form-control";
import { Input, InputGroup, InputRightElement } from "@chakra-ui/input";
import { VStack } from "@chakra-ui/layout";
import { useState } from "react";
import axios from "axios";
import { useToast } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import { ChatState } from "../../Context/ChatProvider";
import ForgotPasswordModal from "./ForgotPasswordModal";

const Login = () => {
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);
  const toast = useToast();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const { setUser } = ChatState();

  const submitHandler = async () => {
    setLoading(true);
    if (!email || !password) {
      toast({
        title: "Заполните все поля",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
      return;
    }

    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const { data } = await axios.post(
        "/api/user/login",
        { email, password },
        config
      );

      toast({
        title: "Добро пожаловать в клуб!",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "bottom",
      });
      setUser(data);
      localStorage.setItem("userInfo", JSON.stringify(data));
      setLoading(false);
      const pending = localStorage.getItem("pendingInvite");
      if (pending) {
        localStorage.removeItem("pendingInvite");
        history.push(`/join/${pending}`);
      } else {
        history.push("/chats");
      }
    } catch (error) {
      toast({
        title: "Не получилось войти",
        description: error.response?.data?.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
    }
  };

  return (
    <VStack spacing="12px">
      <FormControl id="email" isRequired>
        <FormLabel color="#243D27">Почта</FormLabel>
        <Input
          value={email}
          type="email"
          placeholder="you@example.com"
          onChange={(e) => setEmail(e.target.value)}
        />
      </FormControl>
      <FormControl id="password" isRequired>
        <FormLabel color="#243D27">Пароль</FormLabel>
        <InputGroup size="md">
          <Input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type={show ? "text" : "password"}
            placeholder="Введите пароль"
          />
          <InputRightElement width="4.5rem">
            <Button
              h="1.75rem"
              size="sm"
              variant="ghost"
              colorScheme="pine"
              onClick={handleClick}
            >
              {show ? "Скрыть" : "Показать"}
            </Button>
          </InputRightElement>
        </InputGroup>
      </FormControl>
      <Button
        colorScheme="burgundy"
        width="100%"
        h="46px"
        style={{ marginTop: 18 }}
        onClick={submitHandler}
        isLoading={loading}
        boxShadow="0 10px 24px -10px rgba(141, 65, 75, 0.55)"
        _hover={{ bg: "#7A3841", transform: "translateY(-1px)" }}
        _active={{ bg: "#632D35", transform: "none" }}
      >
        Войти
      </Button>
      <ForgotPasswordModal>
        <Button
          variant="link"
          size="sm"
          colorScheme="pine"
          fontWeight={400}
          opacity={0.8}
        >
          Забыли пароль?
        </Button>
      </ForgotPasswordModal>
    </VStack>
  );
};

export default Login;
